// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/.store/css-loader@3.6.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".last-topic_boxs{margin-left:40px;display:none}.last-topic_boxs .el-input--mini,.last-topic_boxs span{margin-left:10px}.last-topic_boxs.down{display:block}", ""]);
// Exports
module.exports = exports;
